import invariant from 'react-utils/invariant';
export const componentFunctionInvariant = (component, functions) => {
  for (const func of functions) {
    invariant(!!component.prototype[func], 'Component missing required function %s', func);
  }
};